import { useQuery } from "@tanstack/react-query"
import { type RouterOutputs } from "@tokenterminal/core/utils/trpc"
import { useTRPC } from "utils/trpc"

export type MetricConfiguration =
  RouterOutputs["metrics"]["getMetricsConfiguration"]["data"][number]

export const useMetricsConfigurationList = () => {
  const trpc = useTRPC()
  const { data, ...rest } = useQuery(
    trpc.metrics.getMetricsConfiguration.queryOptions(undefined, {
      staleTime: 1000 * 60 * 10,
    })
  )

  return {
    data: data?.data,
    ...rest,
  }
}
